module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCRegular.5be2391.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCRegular.woff2
// module id = GKWp
// module chunks = 0